const footerLinks = {
  help: [
    {
      href: "/contact-us-for-car-parts",
      title: "Contact Us for Assistance and Support",
      name: "footer.Help_Center",
    },
    {
      href: "/account/orders",
      title: "Access Your Account's Order Tracking and History",
      name: "footer.Track_My_Order",
    },
    {
      href: "/returns",
      title: "Hassle-Free Returns and Exchanges",
      name: "footer.Return_Exchange",
    },
    {
      href: "/questions-about-autoparts",
      title: "Explore Answers to Common Inquiries in Our FAQs",
      name: "footer.FAQs",
    },
    {
      href: "/warranty-on-auto-parts",
      title: "PartsAvatar Warranty Policy",
      name: "footer.Warranty_Policy",
    },
  ],
  education: [
    {
      href: "/blog",
      title: "Browse our Comprehensive Collection of Informative Articles",
      name: "footer.Blog",
    },
    {
      href: "/articles/ultimate-buying-guides",
      title: "Find Valuable Advice in Our Ultimate Buying Guides",
      name: "footer.CarParts_Buying_Guide",
    },
    {
      href: "/questions-about-autoparts",
      title: "Receive Expert Vehicle Fitment Assistance",
      name: "footer.Fitment_Guide",
    },
    {
      href: "/questions-about-autoparts",
      title: "Access Valuable Installation Advice and Tips",
      name: "footer.Installation_Tips",
    },
  ],
  accounts: [
    {
      href: "/account/overview",
      title: "View and Manage Your Purchase History",
      name: "My Account",
    },
    {
      href: "/account/orders",
      title: "Access a Detailed List of Your Purchase Orders",
      name: "footer.My_Order",
    },
  ],
  services: [
    {
      href: "/best-selling-auto-parts",
      title: "Explore Our Top-Selling Automotive Components",
      name: "footer.Shop_by_Parts",
    },
    {
      href: "/find-original-oem-auto-parts-oem-manufacturers-and-oem-suppliers",
      title: "Search for Genuine Original Equipment Manufacturer (OEM) Auto Parts",
      name: "footer.Shop_by_Brands",
    },
    {
      href: "/auto-parts-free-shipping-canada",
      title: "FREE 1-3 day delivery over $99* on all auto parts orders",
      name: "footer.Shipping_Information",
    },
    {
      href: "/rapid-delivery",
      title: "Get Your Order Lightning-Quick with Rapid Local Delivery",
      name: "Same Day Delivery",
    },
    {
      href: "/in-store-pickup",
      title: "Shop Auto Parts Online and Conveniently Pickup at Your Nearest PartsAvatar Store",
      name: "footer.In_store_Pickup_Process",
    },
  ],
  about: [{
    href: "/about-us",
    title: "Discover Our Company's Origins and Values",
    name: "footer.Our_Story",
  }, {
    href: "https://www.trustpilot.com/review/partsavatar.ca",
    ariaLabel: "sitejabber reviews",
    title: "Customer Reviews and Feedback for PartsAvatar",
    name: "footer.Customer_Review",
  }, {
    href: "/careers",
    title: "Explore Career Opportunities and Join Our Team",
    name: "footer.Careers",
  }, {
    href: "/articles/right-to-repair",
    title: "Explore Canada's Right to Repair Movement for Vehicle Owners",
    name: "footer.Right_to_Repair",
  }, {
    href: "/articles/sustainable-mobility",
    title: "Discover Environmentally Friendly and Sustainable Solutions",
    name: "footer.Sustainable_Mobility",
  }],
};

export default footerLinks;
